import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 flex justify-center" data-id="element-65">
      <div className="w-full max-w-3xl" data-id="element-66">
        <FadeIn className="relative flex flex-col items-center text-center" data-id="element-67">
          {/* Shield border container */}
          <div className="relative w-full bg-surface rounded-3xl overflow-hidden shadow-2xl shadow-black/50 border border-mint/30" data-id="element-68">
            {/* Top accent */}
            <div className="absolute top-0 left-0 w-full h-2 bg-mint" data-id="element-69" />

            {/* Shield glow background */}
            <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,_rgba(74,222,128,0.1)_0%,_transparent_60%)]" data-id="element-70" />

            {/* Large shield watermark behind content */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.05]" data-id="element-71">
              <ShieldCheck size={280} className="text-mint" strokeWidth={1} data-id="element-72" />
            </div>

            <div className="relative z-10 p-8 md:p-12 flex flex-col items-center" data-id="element-73">
              {/* Shield icon centered */}
              <div className="w-20 h-20 rounded-full bg-mint/10 border-2 border-mint/30 flex items-center justify-center mb-5 shadow-[0_0_30px_rgba(74,222,128,0.2)]" data-id="element-74">
                <ShieldCheck size={40} className="text-mint" data-id="element-75" />
              </div>

              <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-mint leading-tight drop-shadow-[0_0_10px_rgba(74,222,128,0.2)]" data-id="element-76">
                GARANTÍA SALUD EN TU PLATO™ — 7 DÍAS
              </h2>

              <div className="space-y-3 text-lg md:text-xl text-dark/90 max-w-2xl" data-id="element-77">
                <p data-id="element-78">
                  Abrís los 6 tomos. Revisás los bonos. Los usás en consulta si
                  querés.
                </p>
                <p className="font-bold text-mint text-xl md:text-2xl drop-shadow-[0_0_8px_rgba(74,222,128,0.2)]" data-id="element-79">
                  Si en 7 días no era lo que esperabas: Te devolvemos el 100%.
                </p>
                <p className="text-dark/70" data-id="element-80">
                  Sin preguntas. Sin formularios. Sin drama.
                </p>
              </div>
            </div>

            {/* Bottom accent */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-mint/40" data-id="element-81" />
          </div>
        </FadeIn>
      </div>
    </section>;
}